import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '../services/translate.service';
import { DEFAULT_LANGUAGE, HEADER_ACCEPT_LANGUAGE } from '../../shared/constants/translation-config';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    try {
      const translateService = this.injector.get(TranslateService);
      const currentLang = translateService.currentLang();

      const modifiedReq = req.clone({
        setHeaders: {
          [HEADER_ACCEPT_LANGUAGE]: currentLang
        }
      });

      return next.handle(modifiedReq);
    } catch (error) {
      const modifiedReq = req.clone({
        setHeaders: {
          [HEADER_ACCEPT_LANGUAGE]: DEFAULT_LANGUAGE
        }
      });

      return next.handle(modifiedReq);
    }
  }
}
